import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import AuthLayout from '../components/AuthLayout';
import { dmClient } from '../services/dmClient';

/**
 * Shared "choose a new password" flow, used by both password-reset and
 * invite-accept (both consume a reset-type JWT and POST /auth/reset-password).
 */
export default function SetPasswordPage({ title, subtitle, cta }) {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (!token) {
      setError('This link is missing its token.');
      return;
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await dmClient.post('/auth/reset-password', { token, password });
      setDone(true);
    } catch (err) {
      setError(err?.response?.data?.error || 'This link is invalid or has expired.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title={title} subtitle={subtitle} footer={<Link to="/login">Back to sign in</Link>}>
      {done ? (
        <div className="auth-success">
          <p>Your password has been set. You can now sign in.</p>
          <Link to="/login" className="auth-submit" style={{ display: 'inline-block', textAlign: 'center', textDecoration: 'none' }}>
            Go to sign in
          </Link>
        </div>
      ) : (
        <form className="auth-form" onSubmit={submit}>
          {error && <div className="auth-error">{error}</div>}
          <label className="auth-field">
            <span>New password</span>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                   placeholder="At least 8 characters" autoComplete="new-password" disabled={loading} required />
          </label>
          <label className="auth-field">
            <span>Confirm password</span>
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
                   placeholder="Re-enter password" autoComplete="new-password" disabled={loading} required />
          </label>
          <button type="submit" className="auth-submit" disabled={loading}>
            {loading ? 'Saving…' : cta}
          </button>
        </form>
      )}
    </AuthLayout>
  );
}
